import { message } from '@whalecloud/fdx';
import { i18n } from 'fishx';
import {
  // getIcons,
  getMenus,
  getAllMenus,
  getSingleMenus,
  getSonMenus,
  changeDirs,
  changeMenus,
  addSonMenus,
  deleteDir,
  deleteMenu,
  deleteSingleMenu,
} from '@pages/MenuMgr/services/menu';

const handleDirMenus = (data, parent) => {
  if (!data || data.length <= 0) return [];
  const newData = [];
  data.map(item => {
    const result = {
      ...item,
      key: parent ? `${parent.key}.${item.dirId}` : item.dirId.toString(),
      privName: item.dirName,
      type: 'parent',
      children: [],
    };
    if (parent) result.parentId = parent.dirId;
    else if (item.dirId !== -1) result.parentId = -1;
    newData.push(result);
    return newData;
  });
  return newData;
};

const handleSonMenus = (data, parent) => {
  if (!data || data.length <= 0) return [];
  const newData = [];
  const { dirId, key } = parent;
  data.map(item => {
    newData.push({
      ...item,
      parentId: dirId,
      dirId: item.menuId,
      key: `0.${key}.${item.menuId}`,
      type: 'son',
    });
    return newData;
  });
  return newData;
};

const arrayToTree = (array, id = 'dirId', pid = 'parentId', children = 'children') => {
  const data = JSON.parse(JSON.stringify(array));
  const result = [];
  const hash = {};
  data.forEach((item, index) => {
    hash[data[index][id]] = data[index];
  });

  data.forEach(item => {
    const hashVP = hash[item[pid]];
    if (hashVP) {
      if (!hashVP[children]) {
        hashVP[children] = [];
      }
      hashVP[children].push(item);
    } else {
      const itemN = item;
      const { menuId, dirId } = itemN;
      if (dirId !== -1 && (!menuId || menuId === undefined)) {
        itemN.children = [];
      }
      result.push(itemN);
    }
  });
  return result;
};

export default {
  namespace: 'menu',

  state: {
    dataArr: [],
    data: [],
    // iconArr: [],
    modalMenus: [],
    menuSelectItem: {},
    dirMenuGridSelectedRowKey: 'modalManageList_2',
  },

  effects: {
    // 获取目录List
    *fetch({ payload }, { call, put }) {
      const { index } = payload;
      const { success, data } = yield call(getMenus, index);
      if (success) {
        yield put({
          type: 'saveMenu',
          payload: {
            data,
          },
        });
      } else {
        yield put({
          type: 'clearState',
        });
      }
    },

    // 获取图标
    // *fetchIcons(_, { call, put }) {
    //   const { data } = yield call(getIcons);
    //   yield put({
    //     type: 'saveIcon',
    //     payload: data,
    //   });
    // },

    // 获取单个目录下的所有目录和菜单
    *fetchSon({ payload }, { call, put }) {
      const { record } = payload;
      const { dirId } = record;
      const { success, data } = yield call(getSonMenus, dirId);
      if (success) {
        yield put({
          type: 'saveMenuSon',
          payload: {
            ...data,
            record,
          },
        });
      }
    },

    // 获取modalManage菜单List
    *getAllMenus({ payload }, { call, put }) {
      const { success, data } = yield call(getAllMenus);
      if (success) {
        data.map(v => {
          Object.assign(v, { key: `modalManageList_${v.privId}`, menuId: v.privId });
          return v;
        });
        // const param = {
        //   modalMenus: data,
        // };
        // if (!payload.sonMenus) {
        //   const { privId = null } = payload;
        //   if (!privId) {
        //     [param.menuSelectItem] = data;
        //   } else {
        //     let index = data.findIndex(v => v.privId === privId);
        //     if (index <= -1) index = 0;
        //     param.menuSelectItem = data[index];
        //   }
        // }
        yield put({
          type: 'saveModalMenu',
          payload: {
            modalMenus: data,
            ...payload,
          },
        });
      }
    },

    // 获取单个目录下的所有菜单
    *getSingleMenus({ payload }, { call, put }) {
      const { record } = payload;
      const { dirId } = record;
      const { success, data } = yield call(getSingleMenus, dirId);
      if (success) {
        yield put({
          type: 'getAllMenus',
          payload: {
            sonMenus: data,
            ...payload,
          },
        });
      }
    },

    // 为某个目录新增子菜单
    *addSonMenus({ payload }, { call, put }) {
      const { record, list } = payload;
      const { dirId } = record;
      const { success } = yield call(addSonMenus, dirId, list);
      if (success) {
        message.success(i18n('DIRMENUMGR_ADD_MENU_TO_DIR_SUCCESS'));
        // 添加菜单成功后查找该目录下的所有子菜单
        yield put({
          type: 'fetchSon',
          payload: {
            record,
          },
        });
      }
    },

    // 更新目录
    *changeDirs({ payload }, { call, put }) {
      const { param, method = 'PUT' } = payload;
      const { success, data } = yield call(changeDirs, param, method);
      if (success && data === 'success') {
        message.success(i18n('DIRMENUMGR_MOD_DIR_SUCCESS'));
        yield put({
          type: 'updateAfterChange',
          payload: {
            ...param,
          },
        });
      }
    },

    // 更新菜单
    *changeMenus({ payload }, { call, put, select }) {
      const { param, method = 'PUT', parentId, reload } = payload;
      param.privType = 'M';
      const { success, data, errorMsg } = yield call(changeMenus, param, method);
      if (!data.code) {
        if (success || data === 'failed') {
          message.success(i18n(method === 'PUT' ? 'DIRMENUMGR_MOD_MENU_SUCCESS' : 'DIRMENUMGR_ADD_MENU_SUCCESS'));
          if (parentId) {
            // 编辑菜单后直接更新父目录
            const menu = yield select(state => state.menu);
            const { dataArr } = menu;
            const filter = dataArr.filter(m => m.dirId === parentId);
            yield put({
              type: 'fetchSon',
              payload: {
                record: filter[0],
              },
            });
          } else {
            yield put({
              type: 'getAllMenus',
              payload: {
                privId: param.menuId ? param.menuId : data.menuId,
              },
            });
            if (reload) {
              yield put({
                type: 'fetch',
                payload: {
                  index: 0,
                },
              });
            }
          }
        }
        return success;
      }
      message.warning(data.message);
      return errorMsg;
    },

    // 在某目录下新增目录
    *addDictionary({ payload }, { call, put, select }) {
      const { success, data } = yield call(changeDirs, payload, 'POST');
      if (success) {
        const { dirId, parentId } = data;
        if (dirId) {
          message.success(i18n('DIRMENUMGR_ADD_DIR_SUCCESS'));
          if (parentId) {
            const menu = yield select(state => state.menu);
            const { dataArr } = menu;
            const filter = dataArr.filter(m => m.dirId === parentId);
            yield put({
              type: 'fetchSon',
              payload: {
                record: filter[0],
              },
            });
          } else {
            yield put({
              type: 'updateFatherDir',
              payload: {
                item: data,
              },
            });
          }
        }
      }
    },

    // 删除某个目录(包括其下所有子目录和菜单)
    *deleteDir({ payload }, { call, put, select }) {
      const { record } = payload;
      const { dirId, parentId } = record;
      const { success, data } = yield call(deleteDir, dirId);
      if (success && data === 'success') {
        message.success(i18n('DIRMENUMGR_REM_DIR_SUCCESS'));
        if (parentId && parentId !== -1) {
          const menu = yield select(state => state.menu);
          const { dataArr } = menu;
          const filter = dataArr.filter(m => m.dirId === parentId);
          yield put({
            type: 'fetchSon',
            payload: {
              record: filter[0],
            },
          });
        } else {
          yield put({
            type: 'updateAfterDelete',
            payload: {
              ...record,
            },
          });
        }
      }
    },

    // 删除目录下的某个菜单
    *deleteMenu({ payload }, { call, put, select }) {
      const { parentId, menuList } = payload;
      const { success, data } = yield call(deleteMenu, parentId, menuList);
      if (success && (data === 'success' || data === 'failed')) {
        message.success(i18n('DIRMENUMGR_DEL_MENU_FROM_DIR_SUCCESS'));
        const menu = yield select(state => state.menu);
        const { dataArr } = menu;
        const filter = dataArr.filter(m => m.dirId === parentId);
        yield put({
          type: 'fetchSon',
          payload: {
            record: filter[0],
          },
        });
      }
    },

    // modalManage删除某个菜单
    *deleteSingleMenu({ payload }, { call, put }) {
      const { id } = payload;
      const res = yield call(deleteSingleMenu, id);
      if (res && res.data === 'success') {
        message.success(i18n('DIRMENUMGR_DEL_MENU_SUCCESS'));
        yield put({ type: 'updateModalMenu', payload: { id } });
      } else if (res && res.data) {
        message.error(res.data.message || '删除失败');
      }
      return res;
    },

    // eslint-disable-next-line consistent-return
    *modalMenuGridFilter({ payload }, { select, put }) {
      const gridData = yield select(state => state.menu.modalMenus);
      const searchRecord = gridData.filter(item => item[payload.title] === payload.content);
      if (searchRecord.length) {
        yield put({ type: 'update_modalMenuSelectKey', payload: searchRecord[0].key });
        return searchRecord[0];
      }
    },

    *changeModalMenuKey({ payload }, { put }) {
      yield put({ type: 'update_modalMenuSelectKey', payload });
    },
  },

  reducers: {
    saveMenu(state, { payload }) {
      // 本地分页
      const { data } = payload;
      const topData = {
        dirId: -1,
        dirName: i18n('DIRMENUMGR_DIR_MENU_ROOT'),
        type: 'parent',
        ancestor: true,
        children: [],
      };
      data.push(topData);
      const newData = handleDirMenus(data);
      const tree = arrayToTree(newData);
      const params = {
        data: tree,
      };
      return {
        ...state,
        dataArr: newData,
        ...params,
      };
    },
    updateFatherDir(state, { payload }) {
      const { item } = payload;
      const { dataArr } = state;
      const newDir = handleDirMenus([item]);
      const newData = dataArr.concat(newDir);
      const tree = arrayToTree(newData);
      return {
        ...state,
        dataArr: newData,
        data: tree,
      };
    },
    saveMenuSon(state, { payload }) {
      const { record, dirList, menuList } = payload;
      const { dataArr } = state;
      const { dirId } = record;
      // 首先清空该目录下的子菜单
      const newArr = [];
      dataArr.map(item => {
        const { parentId } = item;
        if (!parentId || parentId !== dirId) {
          newArr.push(item);
        }
        return null;
      });

      let listDir = [];
      if (dirList.length > 0) {
        listDir = handleDirMenus(dirList, record);
      }
      let listMenu = [];
      if (menuList.length > 0) {
        listMenu = handleSonMenus(menuList, record);
      }
      const list = newArr.concat(listDir, listMenu);
      const tree = arrayToTree(list);
      return {
        ...state,
        dataArr: list,
        data: tree,
      };
    },
    // 删除zui外层dir后更新列表
    updateAfterDelete(state, { payload }) {
      const { dirId } = payload;
      const { dataArr } = state;
      let filter = [];
      const idx = [];
      // 最外层
      dataArr.map(item => {
        if (item.parentId === -1 && item.dirId === dirId) {
          idx.push(item.key);
        }
        if (item.parentId !== -1 && item.parentId === dirId) {
          idx.push(item.key);
        }
        return null;
      });
      filter = dataArr.filter(v => idx.indexOf(v.key) === -1);
      const tree = arrayToTree(filter);
      return {
        ...state,
        dataArr: filter,
        data: tree,
      };
    },
    // 修改目录后更新列表
    updateAfterChange(state, { payload }) {
      const { dirId, menuId, ...otherProps } = payload;
      const { dataArr } = state;
      let propKey = '';
      if (dirId && !menuId) {
        // 目录
        propKey = 'dirId';
      } else if (menuId) {
        // 菜单
        propKey = 'menuId';
      }
      dataArr.map((item, index) => {
        if (item[propKey] === payload[propKey]) {
          dataArr[index] = {
            ...item,
            ...otherProps,
            privName: otherProps.dirName || otherProps.privName,
          };
        }
        return null;
      });
      const tree = arrayToTree(dataArr);
      return {
        ...state,
        dataArr,
        data: tree,
      };
    },
    saveIcon(state, { payload }) {
      return {
        ...state,
        iconArr: payload,
      };
    },
    saveModalMenu(state, { payload }) {
      const { modalMenus, sonMenus = [] } = payload;
      let newList = [...modalMenus];
      // 去重求差集
      if (sonMenus.length > 0) {
        const idsArr = [];
        sonMenus.map(item => idsArr.push(item.menuId));
        newList = modalMenus.filter(v => idsArr.indexOf(v.privId) === -1);
      }
      return {
        ...state,
        ...payload,
        modalMenus: newList,
      };
    },
    changeNowIndex(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    menuSelectorModal(state, { payload }) {
      return { ...state, ...payload };
    },
    // 清空某目录dir下的内容
    clearDir(state, { payload }) {
      const { dirId } = payload;
      const { dataArr } = state;
      const newArr = [];
      dataArr.map(item => {
        const { parentId } = item;
        if (!parentId || parentId !== dirId) {
          newArr.push(item);
        }
        return null;
      });
      const tree = arrayToTree(dataArr);
      return {
        ...state,
        dataArr: newArr,
        data: tree,
      };
    },
    clearState(state, { payload }) {
      return {
        ...state,
        ...payload,
        dataArr: [],
        data: [],
        // iconArr: [],
        modalMenus: [],
      };
    },
    destory() {
      return null;
    },
    update_modalMenuSelectKey(state, { payload: data }) {
      return { ...state, dirMenuGridSelectedRowKey: data };
    },

    // 去除模态框中已删除的菜单
    updateModalMenu(state, { payload }) {
      const { id } = payload;
      const { modalMenus } = state;
      const newMenu = modalMenus.filter(x => x.privId !== id);
      return {
        ...state,
        modalMenus: [...newMenu],
      };
    },
  },
};
